import { createIcon } from './createIcon';

/**
 * An "×". One glyph for every dismissal in the app — closing the settings
 * dialog, clearing a search field, dropping a connection — so the gesture
 * looks the same wherever it appears. Size it at the call site; the strokes
 * were drawn to stay crisp from 12px up.
 */
export const CloseIcon = createIcon({
  name: 'CloseIcon',
  viewBox: '0 0 16 16',
  size: 16,
  children: (
    <path
      d="M4 4l8 8M12 4l-8 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  ),
});

export default CloseIcon;
